<!-- Vue 2 / Salt adaptation of swingmx/webclient GenericHeader.vue,
     f0b87657c6450dc12d2dfd286b75f501410dcabd. MIT, Mungai Njoroge.
     Original: docs/third-party/ui-sources/swing/src/components/shared/GenericHeader.vue -->
<template>
  <header class="generichead">
    <div class="before">
      <div class="left">
        <h1 class="title"><slot name="name" /></h1>
        <div v-if="$slots.description" class="desc"><slot name="description" /></div>
      </div>
      <div class="right"><slot name="right" /></div>
    </div>
    <div v-if="$slots.after" class="after"><slot name="after" /></div>
  </header>
</template>
<script>
export default { name: 'SwingGenericHeader' };
</script>
<style scoped>
.generichead { padding:0 0 16px; height:max-content; align-items:center; overflow:hidden; max-width:100%; }
.before { display:grid; grid-template-columns:minmax(0,1fr) max-content; gap:12px; }
.right { display:flex; align-items:center; height:100%; }
.after { margin-top:12px; }
.left { max-width:100%; min-width:0; overflow:hidden; }
.title { margin:0; font-size:24px; line-height:1.35; font-weight:500; max-width:100%; overflow:hidden; text-overflow:ellipsis; }
.desc { margin-top:4px; font-size:14px; line-height:1.5; color:var(--salt-subtext,var(--color-secondary)); }
</style>
